
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import "./NotFound.css"
import notFoundImg from "../../img/split-plug.jpg"
const NotFound = () => {
    const navigate=useNavigate()

    useEffect(() => {
        const timer = setTimeout(() => {
          navigate("/")
        }, 15000)
    
        return () => clearTimeout(timer)
      }, [navigate])
  return (
 <div className='notfound-container'>
    <div className="error404">404</div>
    <span>sayfa bulunamadı</span>
    <div>
        <div>
            Aradığınız sayfa bulunamadı
        </div>
        <div>15 saniye sonra Ana Sayfaya yönlendirileceksiniz...</div>
    </div>
  
      <button className="not-found-button" onClick={()=>navigate("/")}>
        Ana Sayfaya git
      </button>
   
    <img src={notFoundImg} className="notFound-image" alt=""/>
 </div>
  )
}

export default NotFound